import React, { ReactElement } from 'react';
import { MenuProps } from 'antd';
import { Trans } from 'react-i18next';
import { ColumnsType } from 'common/components/antd/Table/Table';
import { Tag } from 'common/components/antd/Tag/Tag';
import { renderCopyableCell } from 'common/components/CopyableCell/CopyableCell';
import TableActionColumnDropdown from 'common/components/TableActionColumnDropdown/TableActionColumnDropdown';
import { IS_ADMIN_FE } from 'common/constants/general-access-role.constants';
import { alphabeticSortFn } from 'common/utils/sort.utils';
import { RenderGUID } from 'domains/accounts/utils/render-account-iban';
import { SStatusCell } from '../customers.page.style';
import { ECustomersColumnKey } from '../enums/customer.enum';
import { TCustomersTableRecord } from '../types/customers.types';

export const getColumns = ({
  menuItems,
  onItemActionClick,
}: {
  menuItems?: MenuProps['items'];
  onItemActionClick?: any;
} = {}): ColumnsType<TCustomersTableRecord> => [
  {
    title: <Trans i18nKey="usrRoleMng.customers.table.column.user" />,
    width: 330,
    key: ECustomersColumnKey.User,
    dataIndex: ECustomersColumnKey.User,
    searchable: false,
    sorter: alphabeticSortFn(ECustomersColumnKey.User),
  },
  {
    title: <Trans i18nKey="usrRoleMng.customers.table.column.externalId" />,
    width: 350,
    key: ECustomersColumnKey.ExternalId,
    dataIndex: ECustomersColumnKey.ExternalId,
    searchable: false,
    render: renderCopyableCell,
  },
  {
    title: <Trans i18nKey="usrRoleMng.customers.table.column.customerGuid" />,
    width: 350,
    key: ECustomersColumnKey.CustomerGuid,
    dataIndex: ECustomersColumnKey.CustomerGuid,
    searchable: false,
    render: (value, record, index): ReactElement =>
      <RenderGUID value={value} index={index} />,
  },
  // {
  //   title: <Trans i18nKey="usrRoleMng.customers.table.column.email" />,
  //   width: 237,
  //   key: ECustomersColumnKey.Email,
  //   dataIndex: ECustomersColumnKey.Email,
  //   searchable: true,
  // },
  // {
  //   title: <Trans i18nKey="usrRoleMng.customers.table.column.phone" />,
  //   width: 248,
  //   key: ECustomersColumnKey.Phone,
  //   dataIndex: ECustomersColumnKey.Phone,
  //   searchable: true,
  // },
  {
    title: <Trans i18nKey="usrRoleMng.customers.table.column.branch" />,
    width: 350,
    key: ECustomersColumnKey.Branch,
    dataIndex: ECustomersColumnKey.Branch,
    searchable: false,
  },
  {
    title: <Trans i18nKey="usrRoleMng.customers.table.column.segment" />,
    width: 349,
    key: ECustomersColumnKey.Segment,
    dataIndex: ECustomersColumnKey.Segment,
    searchable: false,
  },
  {
    title: <Trans i18nKey="usrRoleMng.customers.table.column.status" />,
    width: 327,
    key: ECustomersColumnKey.Status,
    dataIndex: ECustomersColumnKey.Status,
    searchable: false,
    render: (status: number) => (
      <SStatusCell>
        <Tag color={[undefined, 'green', 'volcano'][status]}>{['Closed', 'Active', 'Blocked'][status]}</Tag>
      </SStatusCell>
    ),
  },
  ...(!IS_ADMIN_FE
    ? [
        {
          title: '',
          width: 20,
          key: ECustomersColumnKey.Menu,
          dataIndex: ECustomersColumnKey.Menu,
          searchable: false,
          render: (status: number, record: any) => (
            <TableActionColumnDropdown
              record={record}
              onClickItemAction={onItemActionClick}
              menuItems={menuItems}
            />
          ),
        }
      ]
    : []),
];
